import React from 'react';
import styled, {useTheme} from 'styled-components/native';
import SkeletonPlaceholder from '../skeletonPlaceholder';
import {View} from 'react-native';
import {Theme} from '../../theme/lightTheme';

const Container = styled.View<any>`
  width: 100%;
`;
const ItemContainer = styled.View<any>`
  width: 100%;
  background-color: ${({theme}) => theme.cardBackground};
  margin-bottom: ${({theme}) => theme.text.s12}px;
  border-radius: 16px;
  padding: 5%;
`;
const LatestArticleSkeleton = ({isTable}: {isTable?: boolean}) => {
  const theme = useTheme() as Theme;
  return (
    <Container isTable={isTable}>
      <View
        style={{
          flexDirection: 'row',
          paddingBottom: '5%',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}>
        <View
          style={{
            flex: 1,
            flexDirection: 'row',
            alignItems: 'center',
          }}>
          <SkeletonPlaceholder
            width={theme.text.s1 * 1.1}
            height={theme.text.s1 * 1.1}
            borderRadius={100}
          />
          <SkeletonPlaceholder
            marginLeft={theme.text.s12 / 2}
            width={'40%'}
            height={16}
            borderRadius={100}
          />
        </View>
        {[0, 1, 3].map(item => (
          <SkeletonPlaceholder
            key={item}
            width={theme.text.s1}
            height={theme.text.s1}
            borderRadius={100}
            marginLeft={theme.text.s12 / 2}
          />
        ))}
      </View>
      {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map(item => (
        <ItemContainer isTable={isTable} key={item}>
          <SkeletonPlaceholder
            width={isTable ? '90%' : '100%'}
            height={16}
            borderRadius={100}
          />
          {item === 0 && (
            <>
              <SkeletonPlaceholder
                width={'60%'}
                height={16}
                borderRadius={100}
                marginTop={isTable ? 10 : '5%'}
              />
              <SkeletonPlaceholder
                width={'30%'}
                height={16}
                borderRadius={100}
                marginTop={isTable ? 10 : '5%'}
              />
            </>
          )}
          {item === 7 && (
            <>
              <SkeletonPlaceholder
                width={'90%'}
                height={16}
                borderRadius={100}
                marginTop={isTable ? 10 : '5%'}
              />
              <SkeletonPlaceholder
                width={'90%'}
                height={16}
                borderRadius={100}
                marginTop={isTable ? 10 : '5%'}
              />
              <SkeletonPlaceholder
                width={'60%'}
                height={16}
                borderRadius={100}
                marginTop={isTable ? 10 : '5%'}
              />
              <SkeletonPlaceholder
                width={'40%'}
                height={16}
                borderRadius={100}
                marginTop={isTable ? 10 : '5%'}
              />
            </>
          )}
        </ItemContainer>
      ))}
    </Container>
  );
};

export default LatestArticleSkeleton;
